import { isOnLine as s } from "../../utils/index19.js";
import { V3toVector3 as t } from "../index9.js";
function m(n, o, e = 0.01) {
  const i = t(o[0]), r = t(o[1]);
  return s(t(n[0]), i, r, e) && s(t(n[1]), i, r, e);
}
export {
  m as isLineInsideLine
};
//# sourceMappingURL=index14.js.map
